import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import CountUp from "react-countup";
import { Link } from "react-router-dom";

const Revenue = (param) => {
  const [chartData, setChartData] = useState([]);
  const [chartCategory, setChartCategory] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [donutchartcustomerColors, setdonutchartcustomerColors] = useState([]);
  const [donutlabel, setdonutlabel] = useState([]);
  const [series, setseries] = useState([]);
  const linechartcustomerColors = ["#9fc5e8", "#f596fb", "#BDB395", "#75fb4c", "#FFC107", "#75fbfd"];

  useEffect(() => {
    setProductCount(param.product.length);
  }, [param.product]);

  useEffect(() => {
    if (param.data && param.data["chart"]) setChartData(param.data["chart"]);
    if (param.data && param.data["chartcategory"]) setChartCategory(param.data["chartcategory"]);

    let ser = [];
    let col = [];
    let lbl = [];
    for (const deal of (param.data["dealCount"] || [])) {
      let statusId = deal.sales_deal_status ? deal.sales_deal_status.id : 0;
      let result = !isNaN(parseFloat(deal.result)) ? parseFloat(deal.result) : 0;
      if (statusId === 3) {
        ser.push(result);
        col.push("#f596fb");
        lbl.push("BOOKING");
      }

      if (statusId === 4) {
        ser.push(result);
        col.push("#BDB395");
        lbl.push("KANTOR");
      }

      if (statusId === 5) {
        ser.push(result);
        col.push("#75fb4c");
        lbl.push("BANK");
      }

      if (statusId === 6) {
        ser.push(result);
        col.push("#FFC107");
        lbl.push("SP3K");
      }

      if (statusId === 7) {
        ser.push(result);
        col.push("#9ACBD0");
        lbl.push("SP3K FINAL");
      }

      if (statusId === 8) {
        ser.push(result);
        col.push("#75fbfd");
        lbl.push("AKAD");
      }
    }
    setdonutchartcustomerColors(col);
    setseries(ser);
    setdonutlabel(lbl);
  }, [param.data]);
  return (
    <React.Fragment>
      <Row>
        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">TOTAL PENERIMAAN KAS</p>
                </div>
                <div className="flex-shrink-0">

                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-24 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={(param.data && param.data["sales_sum"]) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 p-0"><span className="text-info fs-15 text-bold"> {param.data && param.data["sales_count"] ? param.data["sales_count"] : 0}</span> transaksi</p>
                  <Link to="/acc-trans" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Laporan Transaksi
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-success"}>
                    <i className="bx bx-dollar"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">TOTAL PIUTANG</p>
                </div>
                <div className="flex-shrink-0">

                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-24 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={(param.data && param.data["receivable_sum"]) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 p-0"><span className="text-info fs-15 text-bold"> {param.data && param.data["receivable_count"] ? param.data["receivable_count"] : 0}</span> transaksi</p>
                  <Link to="/receivable" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Daftar Transaksi
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-success"}>
                    <i className="bx bx-dollar-circle"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">TOTAL PENDAPATAN</p>
                </div>
                <div className="flex-shrink-0">

                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-24 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={(param.data && parseFloat(param.data["receivable_sum"] || 0) + parseFloat(param.data["sales_sum"] || 0)) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 p-0"><span className="text-info fs-15 text-bold"> {(param.data && parseFloat(param.data["receivable_count"] || 0) + parseFloat(param.data["sales_count"] || 0)) ?? 0}</span> transaksi</p>
                  <Link to="/sales" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Daftar Transaksi
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-success"}>
                    <i className="bx bxs-purchase-tag"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">UNIT DIPESAN VS TERSEDIA</p>
                </div>
                <div className="flex-shrink-0">
                  <h5 className={"fs-14 mb-0 text-success"}>
                    <i className={"fs-13 align-middle ri-arrow-right-up-line"}></i> {param.data && param.data["book_count"] ? parseFloat((param.data["book_count"] / productCount) * 100).toFixed(2) + "%" : ""}
                  </h5>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-22 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="" suffix={""} separator="." end={(param.data && param.data["book_count"]) ?? 0} decimals={0} duration={4} />
                      &nbsp; / &nbsp;
                      <CountUp start={0} prefix="" suffix={""} separator="." end={(param.data && param.data["book_count"] && param.data["book_count"] && (productCount - param.data["book_count"])) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 mb-0 p-0"><span className="text-info fs-15 text-bold">{productCount}</span> total unit</p>
                  <Link to="/product" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Daftar Properti
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-success"}>
                    <i className=" ri-hotel-line"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Revenue;
